export const STATE_STORAGE_KEY = 'MCL'
export const API_STORAGE_PREFIX = 'MCL'
export const STORAGE_QUOTA = 'QUOTA'
